import { useTranslation } from 'react-i18next';
import Button from '@/components/base/Button';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20minimal%20product%20display%20with%20soft%20textiles%20and%20fashion%20accessories%20on%20wooden%20surface%2C%20gentle%20natural%20side%20lighting%2C%20clean%20aesthetic%2C%20beige%20and%20warm%20neutral%20tones%2C%20modern%20European%20lifestyle%20photography%2C%20soft%20shadows%2C%20peaceful%20atmosphere%2C%20high%20quality%20editorial%20composition&width=1600&height=600&seq=cta-main-2026&orientation=landscape"
        alt="Kakobuy Spreadsheet CTA"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-xl md:text-3xl lg:text-4xl font-heading font-bold text-white mb-4">
          {t('cta.headline')}
        </h2>
        <p className="text-sm md:text-base text-white/80 max-w-lg mx-auto mb-8">
          {t('cta.subtext')}
        </p>
        <Button variant="primary" href="https://kaspreadsheet.com" className="px-10 py-4 text-base md:text-lg">
          {t('cta.button')}
        </Button>
      </div>
    </section>
  );
}